module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('steps', {
    attrs: {
      "steps": _vm.steps,
      "request": _vm.request,
      "editable": false,
      "groups": _vm.groups
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "info col-sm-9"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('request-user-linked', {
    attrs: {
      "linked": _vm.otherRequests,
      "request": _vm.request
    }
  }), _vm._v(" "), _vm._l((_vm.fieldsGroups), function(fields, sectionId, i) {
    return _c('table', {
      staticClass: "table table-bordered table-striped",
      staticStyle: {
        "table-layout": "fixed"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "alert alert-info"
    }, [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [(sectionId) ? _c('span', [_vm._v(_vm._s(i + 1) + ". " + _vm._s(_vm.getSection(sectionId).name))]) : _c('span', [_vm._v("Dados")])])])]), _vm._v(" "), _c('tbody', _vm._l((fields), function(field) {
      return (!field.newerVersion) ? _c('tr', {
        key: field.objectId,
        staticClass: "edit-button"
      }, [_c('td', [_c('strong', [_vm._v(_vm._s(field.name))])]), _vm._v(" "), _c('td', [(_vm.showEditField && field.type !== 'computed') ? _c('span', {
        staticClass: "edit-icon pull-right glyphicon glyphicon-edit",
        staticStyle: {
          "padding-left": "5px"
        },
        on: {
          "click": function($event) {
            return _vm.openEditModal(field)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('dynamic-view-field', {
        attrs: {
          "showVersions": true,
          "field": field,
          "sectionOrder": i,
          "sectionId": sectionId,
          "fields": fields
        }
      })], 1)]) : _vm._e()
    }), 0)])
  }), _vm._v(" "), _vm._l((_vm.additionalFields), function(info) {
    return _c('table', {
      staticClass: "table table-bordered table-striped",
      staticStyle: {
        "table-layout": "fixed"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "step-title"
    }, [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Passo: " + _vm._s(info.step.name))])])]), _vm._v(" "), _c('tbody', _vm._l((info.fields), function(field) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(field.name))]), _vm._v(" "), _c('td', [_c('dynamic-view-field', {
        attrs: {
          "field": field,
          "sectionOrder": _vm.i,
          "sectionId": _vm.sectionId
        }
      })], 1)])
    }), 0)])
  })], 2), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "comments"
  }, _vm._l((_vm.comments), function(comment) {
    return (comment.message) ? _c('div', {
      staticClass: "row comment"
    }, [_c('div', {
      staticClass: "comment-timeline",
      class: comment.event
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-11"
    }, [_c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading",
      class: comment.event
    }, [(comment.private) ? _c('span', {
      staticClass: "glyphicon glyphicon-lock",
      attrs: {
        "title": "Comentário privado"
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "comment-user-name"
    }, [_vm._v("Usuário")]), _vm._v(" "), _c('span', {
      staticClass: "comment-date"
    }, [_vm._v(_vm._s(_vm.formatDate(comment.createdAt)))]), _vm._v(" "), _c('span', {
      staticClass: "react-box pull-right"
    }, [_c('button', {
      staticClass: "btn btn-default btn-xs btn-like glyphicon glyphicon-thumbs-up",
      class: {
        liked: comment.likes.indexOf(_vm.user.id) >= 0
      },
      attrs: {
        "disabled": comment.dislikes.indexOf(_vm.user.id) >= 0
      },
      on: {
        "click": function($event) {
          return _vm.like(comment)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "like-count"
    }, [_vm._v(_vm._s(comment.likes.length))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs btn-dislike glyphicon glyphicon-thumbs-down",
      class: {
        disliked: comment.dislikes.indexOf(_vm.user.id) >= 0
      },
      attrs: {
        "disabled": comment.likes.indexOf(_vm.user.id) >= 0
      },
      on: {
        "click": function($event) {
          return _vm.dislike(comment)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dislike-count"
    }, [_vm._v(_vm._s(comment.dislikes.length))])])]), _vm._v(" "), (comment.message) ? _c('div', {
      staticClass: "panel-body comment-message"
    }, [_c('span', {
      staticClass: "react-box pull-right"
    }, [(comment.owner.objectId === _vm.user.id && comment.event === 'note') ? _c('button', {
      staticClass: "btn btn-default btn-xs glyphicon glyphicon-trash",
      on: {
        "click": function($event) {
          return _vm.deleteComment(comment)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "speech-bubble-arrow",
      class: comment.event
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(comment.message || '<i>Sem observações</i>')
      }
    })]) : _vm._e()])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.privateComment),
      expression: "privateComment"
    }],
    attrs: {
      "type": "checkbox",
      "name": "private-comment"
    },
    domProps: {
      "checked": Array.isArray(_vm.privateComment) ? _vm._i(_vm.privateComment, null) > -1 : (_vm.privateComment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.privateComment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.privateComment = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.privateComment = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.privateComment = $$c
        }
      }
    }
  }), _vm._v(" Tornar o comentário privado.\n              ")])])], 1)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveComment('note')
      }
    }
  }, [_vm._v("Enviar")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-3"
  }, [(_vm.request.status == 'processing') ? _c('div', [(!_vm.isLastStep && _vm.canTrammit) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary control",
    attrs: {
      "id": "btn-trammit"
    },
    on: {
      "click": function($event) {
        return _vm.openTrammitModal('processing')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-right"
  }), _vm._v(" "), (!_vm.customizations.trammitButton) ? _c('span', [_vm._v("Tramitar")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.trammitButton))])])]) : _vm._e(), _vm._v(" "), (!_vm.seeMore && _vm.canTrammit) ? _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.seeMore = true
      }
    }
  }, [_vm._v("\n          Ver mais opções\n        ")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.seeMore) ? _c('div', {
    staticClass: "row"
  }, [(_vm.canTrammit) ? _c('button', {
    staticClass: "btn btn-success control",
    attrs: {
      "id": "btn-grant"
    },
    on: {
      "click": function($event) {
        return _vm.openTrammitModal('grant')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-thumbs-up"
  }), _vm._v(" "), (!_vm.customizations.grantButton) ? _c('span', [_vm._v("Finalizar com Sucesso")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.grantButton))])]) : _vm._e(), _vm._v(" "), ((_vm.seeMore || _vm.isFirstStep) && _vm.canTrammit) ? _c('button', {
    staticClass: "btn btn-danger control",
    attrs: {
      "id": "btn-deny"
    },
    on: {
      "click": function($event) {
        return _vm.openTrammitModal('deny')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-thumbs-down"
  }), _vm._v(" "), (!_vm.customizations.denyButton) ? _c('span', [_vm._v("Rejeitar")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.denyButton))])]) : _vm._e(), _vm._v(" "), (_vm.seeMore && !_vm.isFirstStep && _vm.canRevert) ? _c('button', {
    staticClass: "btn btn-primary control",
    on: {
      "click": function($event) {
        return _vm.openTrammitModal('revert')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon glyphicon-erase"
  }), _vm._v(" Reverter\n            ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.currentStepActions.length) ? _c('hr') : _vm._e(), _vm._v(" "), _vm._l((_vm.currentStepActions), function(action) {
    return _c('div', {
      staticClass: "row"
    }, [(action.type === 'form') ? _c('button', {
      staticClass: "btn btn-primary control",
      on: {
        "click": function($event) {
          return _vm.openActionModal(action)
        }
      }
    }, [_vm._v(_vm._s(action.name))]) : (action.type === 'link') ? _c('a', {
      staticClass: "btn btn-primary control",
      attrs: {
        "href": action.value,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-new-window"
    }), _vm._v(" " + _vm._s(action.name) + "\n          ")]) : _vm._e()])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.canTrammit) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-default control",
    attrs: {
      "id": "btn-deny"
    },
    on: {
      "click": _vm.inviteUser
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-share"
  }), _vm._v("\n            Convites\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.canTrammit) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-default control",
    attrs: {
      "id": "btn-email"
    },
    on: {
      "click": function($event) {
        return _vm.sendEmail()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-envelope"
  }), _vm._v("\n            Contactar por email\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.canTrammit) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary control",
    attrs: {
      "id": "btn-email",
      "disabled": _vm.ownerInvite !== undefined
    },
    on: {
      "click": _vm.inviteOwner
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-pencil"
  }), _vm._v("\n            Solicitar Correção\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ownerInvite),
      expression: "ownerInvite"
    }],
    staticStyle: {
      "font-size": "10px",
      "color": "gray"
    }
  }, [_vm._v("Requisitante já foi notificado.")])]) : _vm._e()], 2) : _c('div', {
    staticClass: "result text-center"
  }, [(_vm.request.status == 'grant') ? _c('span', {
    staticClass: "glyphicon glyphicon-ok ok"
  }) : _vm._e(), _vm._v(" "), (_vm.request.status == 'deny') ? _c('span', {
    staticClass: "glyphicon glyphicon-remove notOk"
  }) : _vm._e(), _vm._v(" "), (_vm.request.status == 'processing') ? _c('span', {
    staticClass: "glyphicon glyphicon-hourglass wait"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.canReopen) ? _c('button', {
    staticClass: "btn btn-primary control",
    on: {
      "click": function($event) {
        return _vm.openTrammitModal('reopen')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-open"
  }), _vm._v(" Reabrir\n        ")]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('comment-timeline-overview', {
    attrs: {
      "comments": _vm.comments
    }
  })], 1), _vm._v(" "), (_vm.actionFormValues.length) ? _c('div', {
    staticClass: "info col-sm-9"
  }, _vm._l((_vm.actionValuesGroups), function(fields, actionId, i) {
    return _c('table', {
      key: _vm.action,
      staticClass: "table table-bordered table-striped request-table action-fields-table",
      staticStyle: {
        "table-layout": "fixed"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "title"
    }, [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(_vm.getActionName(actionId)))])])]), _vm._v(" "), _vm._l((fields), function(field) {
      return _c('tbody', {
        key: field.objectId
      }, [_c('tr', {
        class: {
          'user-evaluation': field.type == 'user'
        }
      }, [_c('td', [_vm._v(_vm._s(field.name))]), _vm._v(" "), _c('td', [_c('dynamic-view-field', {
        attrs: {
          "field": field,
          "sectionOrder": i,
          "sectionId": _vm.sectionId
        }
      })], 1)])])
    })], 2)
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [(_vm.commentEvent == 'processing') ? _c('span', [(!_vm.customizations.trammitButton) ? _c('span', [_vm._v("Tramitar Requisição")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.trammitButton))])]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'grant') ? _c('span', [(!_vm.customizations.grantButton) ? _c('span', [_vm._v("Aprovar Requisição")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.grantButton))])]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'deny') ? _c('span', [(!_vm.customizations.denyButton) ? _c('span', [_vm._v("Rejeitar Requisição")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.denyButton))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_c('strong', [_vm._v("Atenção: ")]), _vm._v("\n          Tem certeza que deseja \n          "), (_vm.commentEvent == 'processing') ? _c('span', [_vm._v("tramitar a requisição para o próximo passo ("), _c('strong', [_vm._v(_vm._s(_vm.getNextStep()))]), _vm._v(")?")]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'grant') ? _c('span', [_vm._v("finalizar o processamento com "), _c('strong', {
    staticClass: "grant"
  }, [_vm._v("sucesso")]), _vm._v("?")]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'deny') ? _c('span', [_c('strong', {
    staticClass: "deny"
  }, [_vm._v("rejeitar")]), _vm._v(" a requisição e finalizar o processo?")]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'reopen') ? _c('span', [_vm._v("reabrir a requisição?")]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'revert') ? _c('span', [_vm._v("reverter a requisição para o passo anterior?")]) : _vm._e()]), _vm._v(" "), (_vm.privateStepFields.length > 0) ? _c('fieldset', [_c('legend', [_vm._v("Informações Privadas")]), _vm._v(" "), _vm._l((_vm.privateStepFields), function(formField) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": formField.objectId
      }
    }, [_vm._v("\n              " + _vm._s(formField.name)), (formField.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "text-muted field-desc"
    }, [_vm._v(_vm._s(formField.description))]), _vm._v(" "), (formField.type === 'text') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (formField.type === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "4",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'link') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "url",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'number') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'date') ? _c('datepicker', {
      attrs: {
        "type": "date",
        "clear-button": true,
        "required": "",
        "format": "dd/MM/yyyy",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId,
        "language": "pt-br",
        "input-class": "form-control field-date"
      },
      model: {
        value: (formField.value),
        callback: function($$v) {
          _vm.$set(formField, "value", $$v)
        },
        expression: "formField.value"
      }
    }) : (formField.type === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": 'Entre com o(a) ' + formField.name
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(formField, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((formField.options), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option.name))])
    }), 0) : (formField.type === 'file') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "file",
        "required": "",
        "id": formField.objectId
      },
      on: {
        "change": function($event) {
          return _vm.onChange(formField, $event)
        }
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.publicStepFields.length > 0) ? _c('fieldset', [_c('legend', [_vm._v("Informações Públicas")]), _vm._v(" "), _vm._l((_vm.publicStepFields), function(formField) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": formField.objectId
      }
    }, [_vm._v("\n              " + _vm._s(formField.name)), (formField.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "text-muted field-desc"
    }, [_vm._v(_vm._s(formField.description))]), _vm._v(" "), (formField.type === 'text') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (formField.type === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "4",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'link') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "url",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'number') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'date') ? _c('datepicker', {
      attrs: {
        "type": "date",
        "clear-button": true,
        "required": "",
        "format": "dd/MM/yyyy",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId,
        "language": "pt-br",
        "input-class": "form-control field-date"
      },
      model: {
        value: (formField.value),
        callback: function($$v) {
          _vm.$set(formField, "value", $$v)
        },
        expression: "formField.value"
      }
    }) : (formField.type === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": 'Entre com o(a) ' + formField.name
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(formField, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((formField.options), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option.name))])
    }), 0) : (formField.type === 'file') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "file",
        "required": "",
        "id": formField.objectId
      },
      on: {
        "change": function($event) {
          return _vm.onChange(formField, $event)
        }
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Comentário")]), _vm._v(" "), _c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.contentModal),
      callback: function($$v) {
        _vm.contentModal = $$v
      },
      expression: "contentModal"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "footer",
      "id": "btn-confirm"
    },
    on: {
      "click": function($event) {
        return _vm.prepareFieldsToSave()
      }
    },
    slot: "footer"
  }, [_vm._v("Confirmar")])]) : _vm._e(), _vm._v(" "), (_vm.showActionModal) ? _c('modal', {
    on: {
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.currentAction.name))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.loadingAction) ? _c('div', [_c('loader')], 1) : _c('div', {
    staticClass: "form"
  }, [(!_vm.actionFields.length) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n            Nenhum campo para avaliação foi cadastrado.\n          ")]) : _vm._l((_vm.actionFields), function(formField) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": formField.objectId
      }
    }, [_vm._v("\n              " + _vm._s(formField.name)), (formField.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "text-muted field-desc"
    }, [_vm._v(_vm._s(formField.description))]), _vm._v(" "), (formField.type === 'text') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (formField.type === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "4",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'link') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "url",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'number') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'date') ? _c('datepicker', {
      attrs: {
        "type": "date",
        "clear-button": true,
        "required": "",
        "format": "dd/MM/yyyy",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId,
        "language": "pt-br",
        "input-class": "form-control field-date"
      },
      model: {
        value: (formField.value),
        callback: function($$v) {
          _vm.$set(formField, "value", $$v)
        },
        expression: "formField.value"
      }
    }) : (formField.type === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": 'Entre com o(a) ' + formField.name
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(formField, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((formField.options), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option.name))])
    }), 0) : (formField.type === 'file') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "file",
        "required": "",
        "id": formField.objectId
      },
      on: {
        "change": function($event) {
          return _vm.onChange(formField, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (formField.type === 'user') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": formField.objectId,
        "readonly": ""
      },
      domProps: {
        "value": _vm.user.get('name')
      }
    }) : _vm._e()], 1)
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "footer",
      "id": "btn-confirm",
      "disabled": !_vm.actionFields.length
    },
    on: {
      "click": function($event) {
        return _vm.processStepActions()
      }
    },
    slot: "footer"
  }, [_vm._v("Confirmar")])]) : _vm._e(), _vm._v(" "), (_vm.showEditModal) ? _c('modal', {
    on: {
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("EDIÇÃO")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('p', [_vm._v("Valor Atual:")]), _vm._v(" "), _c('dynamic-view-field', {
    attrs: {
      "field": _vm.currentEditField
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Novo Valor:")]), _vm._v(" "), _c('dynamic-form-field', {
    attrs: {
      "onChange": _vm.onChange,
      "formField": _vm.newEditField
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "footer",
      "id": "btn-confirm"
    },
    on: {
      "click": function($event) {
        return _vm.saveNewFieldVersion(_vm.currentEditField.objectId, _vm.newEditField)
      }
    },
    slot: "footer"
  }, [_vm._v("Salvar")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Comentários mais recentes")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("(Mensagens)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-user profile"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07fc31fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestDetail.vue
// module id = 1379
// module chunks = 1